// extracted by mini-css-extract-plugin
module.exports = {"popover_item":"popover-item_popover_item__50SiM","active":"popover-item_active__aCWgE"};